import { render, staticRenderFns } from "./AddLinkModal.vue?vue&type=template&id=2bdeed6a&"
import script from "./AddLinkModal.vue?vue&type=script&lang=js&"
export * from "./AddLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLinkModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports